// Клиентский фильтр слов до отправки (ADR-0028): грубый первый барьер для названий и описаний.
// Окончательное решение — за сервером (NAME_INVALID, CHAT_REJECTED); список — основы слов, сверяются без регистра,
// с заменой похожих латинских букв и цифр на кириллицу.
const STEMS = ['хуй', 'хуё', 'хуев', 'пизд', 'ебуч', 'ёбан', 'бляд', 'блят', 'мудак', 'пидор', 'пидар', 'гандон', 'шлюх', 'залуп', 'наркот', 'фашист', 'нацист'];
/** Основы, которые прячутся внутри обычных слов («небаланс», «сукно») — только с начала слова. */
const STEMS_AT_START = ['ебат', 'ебал', 'ебан', 'сука', 'суки', 'сучар'];

const LOOKALIKE: Record<string, string> = { a: 'а', e: 'е', o: 'о', p: 'р', c: 'с', x: 'х', y: 'у', k: 'к', m: 'м', t: 'т', b: 'б', h: 'н', '0': 'о', '3': 'з', '6': 'б' };

export function normalizeForFilter(s: string): string {
  return s.toLowerCase().replace(/[a-z0-9]/g, (ch) => LOOKALIKE[ch] ?? ch).replace(/[^а-яё]/g, '');
}

/** true — текст не пропускаем (подпись «Такое название нельзя»). */
export function isBlocked(s: string): boolean {
  const words = s.split(/[\s.,!?;:_-]+/).map(normalizeForFilter).filter(Boolean);
  const joined = words.join('');
  return STEMS.some((st) => joined.includes(st)) || words.some((w) => STEMS_AT_START.some((st) => w.startsWith(st)));
}
